import React from 'react'
import { CSSObject } from '@emotion/react'
import { Box, Color, withCitrusTheme } from '@gousto-internal/citrus-react'

// Placeholder "New" tag for the "Cooked by us" toggle label — extracted to its own file so it's a
// single, easy swap once a final New Badge component is provided by design.
const NewTagRoot = withCitrusTheme(Box, (theme) => [
  {
    backgroundColor: theme.color(Color.Success_600),
    color: theme.color(Color.White),
    borderRadius: '4px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    fontFamily: theme.tokens.FontFamilies.book,
    fontWeight: 400,
  } as CSSObject,
  theme.responsiveFont(2) as CSSObject,
  theme.responsiveSpacing(0.25, ['paddingTop', 'paddingBottom']) as CSSObject,
  theme.responsiveSpacing(2, ['paddingLeft', 'paddingRight']) as CSSObject,
])

export const CWCNewTag = ({ children }: { children: React.ReactNode }) => (
  <NewTagRoot>{children}</NewTagRoot>
)
